// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCzpC2HVC4Bi5f5KFLavDyJ1jpCPnaJPVs",
  authDomain: "group7-majorcompass-20e28.firebaseapp.com",
  projectId: "group7-majorcompass-20e28",
  storageBucket: "group7-majorcompass-20e28.appspot.com",
  messagingSenderId: "766629938426",
  appId: "1:766629938426:web:a9afabf97f22e728c47543",
  measurementId: "G-JHR2LQPELB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// const db = getDatabase(app);
const db = getDatabase();

export default db;